import { Sparkles } from "lucide-react";
import { PageHeader, PrivacyBadge } from "./adminUi";

export default function AdminComingSoonScreen({ title = "This view", note = "", testId = "admin-coming-soon", icon: Icon = Sparkles }) {
  return (
    <div data-testid={testId}>
      <PageHeader title={title} actions={<PrivacyBadge />} />
      <div className="k-card flex flex-col items-center text-center" style={{ padding: "3.5rem 2rem" }}>
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4" style={{ background: "rgba(29,95,212,0.1)", color: "#1D5FD4" }}>
          <Icon size={26} />
        </div>
        <h2 className="klareet-serif mb-2" style={{ fontSize: "1.5rem", color: "#131822" }}>Arriving in the next release</h2>
        <p className="k-quiet" style={{ maxWidth: "34rem", lineHeight: 1.6 }}>
          {note || "This surface is on the build. It will land here soon, aggregate and privacy safe like the rest of your console."}
        </p>
      </div>
    </div>
  );
}
